<template>
  <div class="cancellation">
    <el-dialog destroy-on-close :visible.sync="showDialog" title="票据作废" width="460px" append-to-body
               :close-on-click-modal='false' :close-on-press-escape='false' :before-close="handClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="96px" v-if="showDialog">
        <el-form-item label="作废票张数" prop="invalidateNum">
          <el-input v-input-filter="{ min: 1, max: ticketGetRow.remainingNum, precision: 2 }" type="text"
                    placeholder="请输入作废票张数" v-model="form.invalidateNum"></el-input>
        </el-form-item>
        <el-form-item label="当前票号">
          {{ ticketCurrentNo }}
        </el-form-item>
        <el-form-item label="剩余票张数">
          {{ ticketGetRow.remainingNum - form.invalidateNum }}
        </el-form-item>

        <el-form-item label-width="0">
          <div class="main-form-btn">
            <el-button @click="handClose">取消</el-button>
            <el-button type="primary" @click="actionFn" :loading="loading">确定</el-button>
          </div>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "cancellation",
  components: {},
  props: {
    value: {
      default: false
    },
    ticketGetRow: {
      default: () => ({
        remainingNum: 1
      })
    }
  },
  computed: {
    ticketCurrentNo() {
      let ticketCurrentNoNum = parseInt(this.ticketGetRow.ticketCurrentNo) + Number(this.form.invalidateNum)
      let num = String(this.ticketGetRow.ticketCurrentNo).length - String(parseInt(this.ticketGetRow.ticketCurrentNo)).length
      let str = ''
      for (let i = 0; i < num; i++) {
        str += '0'
      }
      return str + String(ticketCurrentNoNum)
    }
  },
  data() {
    return {
      showDialog: false,
      form: {
        invalidateNum: ''
      },
      rules: {
        invalidateNum: [{required: true, message: '请输入作废票张数', trigger: ['blur', 'change']}],
      },
      loading: false
    }
  },
  watch: {
    value: {
      handler() {
        if (this.value) {
          this.showDialog = this.value
          if (this.value) {
            /* 预留初始化逻辑 */
          }
        }
      }
    }
  },
  methods: {
    handClose() {
      this.showDialog = false
      this.$emit('input', false)
    },
    async actionFn() {
      const valid = await this.$refs.form.validate().catch(err => err);
      const url = "/api/v1/manage/ticket/invalidate"
      if (typeof valid === 'boolean' && valid) {
        this.loading = true
        const {code} = await this.$axios.post(url, {
          ...this.form,
          ticketReceiveId: this.ticketGetRow.id
        })
        this.loading = false
        if (code === 1) {
          this.$message.success('操作成功')
          this.handClose()
          this.form.invalidateNum = ''
          this.$emit('handChange', this.ticketGetRow)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>